export default "/corgi/pageapps/purchase/_next/static/media/safari-pinned-tab.208ac0c1.svg";